module.exports = __webpack_public_path__ + "static/media/logo.ffe043fd.png";